export const LoginFooter = () => {
  return (
    <div className="flex w-full justify-center gap-5 px-5 py-3 text-xs font-normal leading-normal text-neutral-300 mobile:text-3xs mobile:leading-normal">
      <div>© {new Date().getFullYear()} Elys Network</div>

      {/* <Link
        className="text-neutral-300"
        href={{
          href: TERMS_LINK,
        }}
        target="_blank">
        Terms of Service
      </Link> */}

      {/* <Link
        href={{
          href: PRIVACY_LINK
        }}>
        Privacy Policy
      </Link> */}
    </div>
  );
};
